<template>
  <div v-if="shouldDisplayTags">
    <h3 class="heading-3" data-selector="tags-pp-title">
      {{ i18n(translations.title) }}
    </h3>
    <div class="-mb-8 mt-20 flex overflow-x-auto pb-8 md:mt-32 md:flex-wrap">
      <RevButtonTiny
        v-for="tag in tags"
        :key="tag.title"
        class="mb-8 mr-8"
        data-selector="product-tag"
        :to="tag.link"
        variant="primary"
        @click="trackPopularSearchClick(tag)"
      >
        {{ tag.title }}
      </RevButtonTiny>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { linkBoosterAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonTiny } from '@ds/components/ButtonTiny'

import translations from './PopularSearches.translations'

const i18n = useI18n()
const { trackClick } = useTracking()

const props = defineProps<{
  tags: linkBoosterAPI.GetSeoTagsResponse
}>()

const shouldDisplayTags = computed(() => {
  return props.tags.length > 0
})

function trackPopularSearchClick(
  tag: linkBoosterAPI.GetSeoTagsResponse[number],
) {
  trackClick({ zone: 'tags', name: `product-tag-${tag.slug}` })
}
</script>
